import React from "react";
import {Box, Divider, Paper, Typography} from "@mui/material";

export const OUTCOME_COLORS: Record<string, string> = {
    "Sustained":     "#f44336",
    "Not sustained": "#ff9800",
    "Exonerated":    "#4caf50",
    "Unfounded":     "#2196f3",
    "Withdrawn":     "#9e9e9e",
}

export const CLASS_COLORS = [
    "#5c6bc0","#26a69a","#ef5350","#ab47bc","#42a5f5",
    "#66bb6a","#ffa726","#ec407a","#8d6e63","#78909c",
    "#26c6da","#d4e157","#ff7043","#7e57c2",
]

export function StatCard({label, value, sub}: { label: string; value: number | string; sub?: string }) {
    return (
        <Paper variant="outlined" sx={{p: 2, textAlign: "center"}}>
            <Typography variant="h4" fontWeight={700}>{value}</Typography>
            <Typography variant="body2" color="text.secondary">{label}</Typography>
            {sub && <Typography variant="caption" color="text.disabled">{sub}</Typography>}
        </Paper>
    )
}

export function ChartCard({title, children}: { title: string; children: React.ReactNode }) {
    return (
        <Paper variant="outlined" sx={{p: 2}}>
            <Typography variant="subtitle2" fontWeight={700} textTransform="uppercase"
                        letterSpacing={0.5} gutterBottom>{title}</Typography>
            <Divider sx={{mb: 2}}/>
            {children}
        </Paper>
    )
}

export function ChartTip({active, payload, label}: any) {
    if (!active || !payload?.length) return null
    return (
        <Paper variant="outlined" sx={{p: 1.5, minWidth: 120}}>
            {label && <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>{label}</Typography>}
            {payload.map((p: any) => (
                <Box key={p.name} sx={{display: "flex", justifyContent: "space-between", gap: 2}}>
                    <Typography variant="caption" sx={{color: p.color}}>{p.name}</Typography>
                    <Typography variant="caption" fontWeight={600}>{p.value}</Typography>
                </Box>
            ))}
        </Paper>
    )
}
